import { Component, OnInit } from '@angular/core';
import { CallHistoryService } from '../../call-history.service';
import { getCallHistoryPageSelector } from '../../call-history.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';
import { CallHistorySearchParams } from '../../call-history-params.interface';

@Component({
  selector: 'cc-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss']
})
export class SearchFilterComponent implements OnInit {
  public filters: CallHistorySearchParams;
  constructor(private callHistoryService: CallHistoryService, private store: Store<IState>) {}

  ngOnInit() {
    this.store.select(getCallHistoryPageSelector).subscribe(params => {
      this.filters = params;
    });
  }

  addFilter(type, value) {
    this.callHistoryService.addFilter(type, value, this.callHistoryService.getPagerIndexReset(this.filters.pager));
  }
}
